import React from 'react';
import classNames from 'classnames';

import styles from './CarouselPaginationBullet.css';
import { getScale } from './utils/scale';

interface ICarouselPaginationBullet {
  index: number;
  count: number;
  active: number;
  onClick?(e: React.MouseEvent<HTMLElement>): void;
}

export function CarouselPaginationBullet({ active, index, count, onClick }: ICarouselPaginationBullet) {
  const scale = getScale(index, active, count);

  return (
    <div
      onClick={onClick}
      className={classNames(
        styles['bullet'],
        active === index && styles['active'],
        scale === 'M' && styles['bullet-m'],
        scale === 'S' && styles['bullet-s'],
      )}
    />
  );
}
